// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  env: 'dev',
  graphQlHost: 'https://gsc-athenagenius-appservice-001-d.azurewebsites.net/graphql',
  apiHost: 'https://gsc-athenagenius-appservice-001-d.azurewebsites.net',
  authScope:"c66b72c4-55dc-4dd0-8252-91a2650622f5/.default",
  adalConfig: {
    tenant:     'c1eb5112-7946-4c9d-bc57-40040cfe3a91',
    clientId: '24d475c1-bc16-4652-a843-46f2fde8a6bc',
    endpoints: {
      'https://gsc-athenagenius-appservice-001-d.azurewebsites.net/': 'c66b72c4-55dc-4dd0-8252-91a2650622f5'
    }
  }
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
